import React, {Component} from "react";
import { Link } from "react-router-dom";
import Button from "react-toolbox/lib/button/Button";
import PropTypes from "prop-types";
import "./Pay.css";
import "./paypopup.js";
import {delimit} from "../StringUtils.js";
import ValidatedForm from "./form/ValidatedForm";
import { InputAdapter, DropdownAdapter } from "./form/FormAdapters.js";
import {Errors} from "../Strings";
import { currentUserInfo } from "../App.js";
import axios from "axios";
import qs from "qs";

const PayTypeValues = {
	processCreditCard: 0,
	contactUs: 1
};

// const PayTypes = [
// 	{
// 		value: PayTypeValues.processCreditCard,
// 		label: "Pay with Credit Card Online"
// 	},
// 	{
// 		value: PayTypeValues.contactUs,
// 		label: "Mail a Check or Call with Credit Card"
// 	}
// ];

const PaymentStates = {
	entryForm: 0,
	submitting: 1,
	processExternal: 2,
	showReceipt: 3,
	payableChanged: 4,
	fatalError: 100
};

export default class Pay extends Component {

	constructor(props) {
		super(props);

		this.setPayType = this.setPayType.bind(this);
		this.submitPayment = this.submitPayment.bind(this);
		this.done = this.done.bind(this);
		this.getNoProcessorUI = this.getNoProcessorUI.bind(this);
		this.getPaymentUI = this.getPaymentUI.bind(this);

		this.pastDueInvoiceTotal = props.itemsToPay.pastDueInvoices ?
			props.itemsToPay.pastDueInvoices.reduce((total, inv) => total + inv.receivable, 0.00) : null;
		this.currentInvoiceTotal = props.itemsToPay.currentInvoices ?
			props.itemsToPay.currentInvoices.reduce((total, inv) => total + inv.receivable, 0.00) : null;
		this.prepaidAdTotal = props.itemsToPay.prepaidAds ?
			props.itemsToPay.prepaidAds.reduce((total, ad) => total + ad.totalUnpaid, 0.00) : null;
		this.billedAdTotal = props.itemsToPay.billedAds ?
			props.itemsToPay.billedAds.reduce((total, ad) => total + ad.totalUnpaid, 0.00) : null;


		const defaultPayType = props.paymentConfig.processingEnabled ?
			PayTypeValues.processCreditCard : PayTypeValues.contactUs;

		var defaultPayInfo = null;
		if (props.paymentConfig.processingEnabled) {
			defaultPayInfo = {
				pmtMethod: null,
				cardNumber: null,
				expMonth: null,
				expYear: null,
				cvCode: null,
				cardHolder: null
			};

			const isPresent = (str) => str != null && str.length > 0;
			const propCardHolders = props.paymentConfig.cardHolders ? props.paymentConfig.cardHolders[1] : [];
			const cardHolders = propCardHolders.filter((cardHolder) =>
				isPresent(cardHolder.billStreet) &&
				isPresent(cardHolder.billCity) &&
				isPresent(cardHolder.billState) &&
				isPresent(cardHolder.billPostalCode)
			);
			const cardHolder = cardHolders.length > 0 ? cardHolders[0] : null;
			//Set the address to the first cardholder
			Object.assign(defaultPayInfo, defaultPayInfo, { cardHolder: cardHolder });

			this.cardHolders = cardHolders;

			if (!props.paymentConfig.entervialink) {
				this.paymentMethods = props.paymentConfig.pmtMethods[1].map((payMethod) => {
					return ({
						value: payMethod.code,
						label: payMethod.description
					});
				});
			}

			AuthorizeNetPopup.options.onPopupClosed = this.externalCanceled.bind(this);
			AuthorizeNetPopup.options.onResponse = this.handleExtResponse.bind(this);
		} else {
			this.cardHolders = null;
			this.paymentMethods = [];
		}


		this.state = {
			payType: defaultPayType,
			paymentInfo: defaultPayInfo,
			paymentState: PaymentStates.entryForm,
			paymentError: null,
			fieldValidationMessages: null,
			externalProcessorData: null,
			paymentNumber: null
		};

		window.scrollTo(0,0);
	}

	setPayType(payType) {
		this.setState({payType: payType});
	}

	submitPayment(paymentInfo) {
		var ads = this.props.itemsToPay.prepaidAds ? this.props.itemsToPay.prepaidAds.slice() : [];
		if (this.props.itemsToPay.billedAds) {
			ads.push.apply(ads, this.props.itemsToPay.billedAds); //JS's hacky way of combining arrays
		}
		var invoices = this.props.itemsToPay.pastDueInvoices ? this.props.itemsToPay.pastDueInvoices.slice() : [];
		if (this.props.itemsToPay.currentInvoices){
			invoices.push.apply(invoices, this.props.itemsToPay.currentInvoices);
		}

		const adsPaid = ads.map(ad => {
			return (
				{
					transId: ad.id,
					amount: ad.totalUnpaid
				});
		});
		const invoicesPaid = invoices.map(invoice => {
			return ({
				transId: invoice.id,
				amount: invoice.receivable
			});
		});

		const fullPaymentInfo = Object.assign({}, paymentInfo, {
			adsPaid: adsPaid,
			invoicesPaid: invoicesPaid
		});

		const secureProc = this.props.paymentConfig.secureProc ? this.props.paymentConfig.secureProc : false;

		this.setState({ paymentState: PaymentStates.submitting });

		if (secureProc) {
			//Get the secure token from our server
			const request = {
				method: "get",
				url: "/Payment/secureRequest"
			};

			//console.log("Sending request for secure token: ", request);

			this.props.server(request).then(response => {
				//console.log(("Got secure token: ", response.data);
				this.processSecureToken(fullPaymentInfo, response);
			}).catch(error => {
				var paymentState = PaymentStates.entryForm;
				if (error.response == null || error.response.status == null || error.response.status !== 400) {
					paymentState = PaymentStates.fatalError;
				}

				let userMessages = Errors.messagesForServerError(error);
				this.setState({
					paymentInfo: fullPaymentInfo,
					paymentError: userMessages.requestError,
					fieldValidationMessages: userMessages.fieldErrors,
					paymentState: paymentState
				});
			});

		} else {
			//Nothing extra is needed in the payment for most cases.
			const payment = Object.assign({}, fullPaymentInfo);
			if (this.props.paymentConfig.entervialink) {
				var hostOptions = null;
				let apiBase = this.props.paymentConfig.appBaseURL.replace(/\/portal(\/?)/i, "/adpro");
				if (this.props.paymentConfig.gateway === "authorizeNet")
					hostOptions = {
						hostedPaymentIFrameCommunicatorUrl: "{\"url\":\""
							+ apiBase.concat("/authdotnetcomm.html\"}"),
						hostedPaymentBillingAddressOptions: "{\"show\":false}"
					}
				else
				if (this.props.paymentConfig.gateway === "payflowlink4") {
					const extRtnURL = this.props.paymentConfig.appBaseURL + "extreturn.html";
					const silentPost = apiBase.concat("/rs/hook/paypal");
					hostOptions = {
						RETURNURL: extRtnURL,
						ERRORURL: extRtnURL,
						SILENTPOSTURL: silentPost,
						DISABLERECEIPT: "TRUE",
						TEMPLATE: "MINLAYOUT"
					}
				}
				payment.tokenData = hostOptions;
			}
			this.processPayment(fullPaymentInfo, payment);
		}

	}

	/* 	Sends payment to /Payment/process to charge card.
		`fullPaymentInfo` is all the data from the form.
		This is needed when processing errors.

		`payment` is what needs to be sent to the /Payment/process.
		For some processors, it is just `fullPaymentInfo`, but some like TranSafe
		requires something a little different.
	*/
	processPayment(fullPaymentInfo, payment) {
		const request = {
			method: "post",
			url: "/Payment/process",
			data: JSON.stringify(payment),
		};

		// console.log("Sending payment with request: ", request);
		// console.log("Payment is: ", payment);
		// console.log("Paying ads: ", payment.adsPaid);
		// console.log("Paying invoices: ", payment.invoicesPaid);
		// console.log("request data: ", request.data);

		this.props.server(request).then(response => {
			// console.log("Processed payment, got response: ", response);
			this.handleStdProcessorResponse(fullPaymentInfo, response);
		}).catch(error => {
			var paymentState = PaymentStates.entryForm;
			if (error.response == null || error.response.status == null || error.response.status !== 400) {
				paymentState = PaymentStates.fatalError;
			}

			let userMessages = Errors.messagesForServerError(error);
			this.setState({
				paymentInfo: fullPaymentInfo,
				paymentError: userMessages.requestError,
				fieldValidationMessages: userMessages.fieldErrors,
				paymentState: paymentState
			});
		});
	}

	handleStdProcessorResponse(fullPaymentInfo, response) {
		// console.log("Got payment process data from our server: ", response.data);
		const data = response.data;
		var stateData = {
			paymentError: null,
			fieldValidationMessages: null
		};
		if (fullPaymentInfo !== null)
			stateData.paymentInfo = fullPaymentInfo;
		if (data) {
			const parseErrorMessage = (message) => {
				if (!message) {
					return null;
				}

				var msgStart = message ? message.indexOf("*") : -1;
				msgStart = msgStart > -1 ? msgStart : 0;
				return message.slice(msgStart);
			};

			var message = parseErrorMessage(data.message);
			switch (data.result) {
			case "ACCEPTED":
				stateData.paymentError = null;
				stateData.paymentState = PaymentStates.showReceipt;
				stateData.paymentNumber = data.paymentId;
				break;
			case "DECLINED":
				if (message === null) {
					message = "Declined";
				}
				stateData.paymentError = "Payment was declined. Check the card info and try again.";
				stateData.paymentState = PaymentStates.entryForm;
				stateData.externalProcessorData = null;
				break;
			case "APPLY_ERROR":
				stateData.paymentError = "Your payment was not processed. It appears that the amount due on an item you tried to pay was changed by us. Please click Reload below to see the current state of your account.";
				stateData.paymentState = PaymentStates.payableChanged;
				break;
			case "EXTERNAL":
				this.handleExternalProcessor(data);
				break;
			default:
				var msg = "Sorry, an unknown error occurred trying to process the payment. You will need to reload this page and try again.";
				msg = delimit(msg, message, ": ");
				stateData.paymentError = msg;
				stateData.paymentState = PaymentStates.fatalError;
				stateData.externalProcessorData = null;
			}
		} else {
			stateData.paymentError = "No result was returned from the payment processor.";
			stateData.paymentState = PaymentStates.fatalError;
		}
		this.setState(stateData);
	}

	/*	Sends the secure token returned by our server along with the
		credit card info to TranSafe. TransSafe returns a ticket
		which is then passed to our server, along with the other payment info.
		Our server sends all the info needed to TransSafe, and returns as usual.
	*/
	processSecureToken(fullPaymentInfo, tokenResponse) {
		const token = tokenResponse.data;
		//TranSafe only accepts mmyy for expiration date.
		const strExpYear = fullPaymentInfo.expYear.toString();
		var monetra_exp = strExpYear.length > 2 ? strExpYear.slice(strExpYear.length - 2) : strExpYear;
		var strMonth = fullPaymentInfo.expMonth.toString();
		strMonth = strMonth.length < 2 ? 0 + strMonth : strMonth;
		monetra_exp = strMonth.concat(monetra_exp);

		//monetra_req_timestamp comes back as an array:
		// [0] = java.lang.long
		// [1] = [int representing timestamp]
		//Fields must be in exactly this order (maybe)
		var monetra_fields = {
			username: token.username,
			action: token.action,
			admin: token.admin,
			monetra_req_sequence: token.monetra_req_sequence,
			monetra_req_timestamp: token.monetra_req_timestamp[1],
			monetra_req_hmacsha256: token.monetra_req_hmacsha256,
			monetra_req_fields: token.monetra_req_fields,
			account: fullPaymentInfo.cardNumber.replace(/[- ]/g, ''),
			expdate: monetra_exp,
			cv: (fullPaymentInfo.cvCode == null ? "N" : fullPaymentInfo.cvCode)
		};
		const postURL = token.postURL;

		//Get the ticket from TranSafe
		const monetraReq = {
			method: "POST",
			headers: { "content-type": "application/x-www-form-urlencoded" },
			data: qs.stringify(monetra_fields),
			url: postURL
		};
		//console.log(("Will stringify for monetra: ", monetra_fields);
		//console.log(("Sending request for secure ticket with values: ", monetraReq.data);
		axios(monetraReq).then(response => {
			//console.log(("Got secure ticket, response: ", response);
			//console.log(("Ticket XML: ", response.data);
			//Extract the hash value and ticket number frome the XML.
			var parser = new DOMParser();
			var xmlDoc = parser.parseFromString(response.data, "text/xml");
			const monetra_resp_hmacsha256 = xmlDoc.getElementsByTagName("monetra_resp_hmacsha256")[0].childNodes[0].nodeValue;
			var ticketEl = xmlDoc.getElementsByTagName("ticket");
			var ticket = null;
			if (ticketEl != null && ticketEl.length > 0) {
				ticket = ticketEl[0].childNodes[0].nodeValue;
			}
			//Note that in this case, we only want the last 4 digits of the card number,
			//and do not want the CVV code.
			var paymentInfo = Object.assign({}, fullPaymentInfo);
			paymentInfo.cardNumber = fullPaymentInfo.cardNumber.slice(fullPaymentInfo.cardNumber.length-4);
			delete paymentInfo.cvCode;
			const tokenData = {
				monetra_req_sequence: monetra_fields.monetra_req_sequence,
				monetra_req_timestamp: monetra_fields.monetra_req_timestamp,
				monetra_resp_hmacsha256: monetra_resp_hmacsha256,
				ticket: ticket
			};
			paymentInfo.tokenData = tokenData;
			this.processPayment(fullPaymentInfo, paymentInfo);
		}).catch(error => {
			//console.log(("Got error: ", error);
			var paymentState = PaymentStates.entryForm;
			if (error.response == null || error.response.status == null || error.response.status !== 400) {
				paymentState = PaymentStates.fatalError;
			}

			let userMessages = Errors.messagesForServerError(error);
			this.setState({
				paymentInfo: fullPaymentInfo,
				paymentError: userMessages.requestError,
				fieldValidationMessages: userMessages.fieldErrors,
				paymentState: paymentState
			});
		});

	}

	handleExternalProcessor(processorData) {
		const externalProcessorData = Object.assign({}, processorData);
		externalProcessorData.returnURL = this.props.paymentConfig.appBaseURL;
		let newState = {
			paymentState: PaymentStates.processExternal,
			externalProcessorData: externalProcessorData
		};
		this.setState(newState);
	}

	externalCanceled() {
		const iframe = document.getElementById("iframePayment");
		if (iframe)
			iframe.src = "extpmt.html";
		this.setState({paymentState: PaymentStates.entryForm,
			externalProcessorData: null});
	}

	handleExtResponse(response) {
		const iframe = document.getElementById("iframePayment");
		if (iframe)
			iframe.src = "extpmt.html";
		const request = {
			method: "post",
			url: "/Payment/hostresp",
			data: response
		};
		this.props.server(request).then(procResp => {
			let newPayInfo = Object.assign({}, this.state.paymentInfo);
			let data = procResp.data;
			newPayInfo.pmtMethod = data.pmtMethod;
			newPayInfo.cardNumber = data.cardNumber;
			this.handleStdProcessorResponse(newPayInfo, procResp);
		}).catch(error => {
			var paymentState = PaymentStates.entryForm;
			if (error.response == null || error.response.status == null || error.response.status !== 400) {
				paymentState = PaymentStates.fatalError;
			}

			let userMessages = Errors.messagesForServerError(error);
			this.setState({
				paymentError: userMessages.requestError,
				fieldValidationMessages: userMessages.fieldErrors,
				paymentState: paymentState,
				externalProcessorData: null
			});
		});
	}

	done() {
		this.props.routerHistory.replace("/reload?keepSelect=n");
	}

	//I decided not to do this on APPLY_ERROR because the item being paid might not show up anymore.
	// reload() {
	// 	this.props.routerHistory.replace("/reload?keepSelect=y");
	// }

	render() {
		var ui = this.state.payType === PayTypeValues.processCreditCard ? this.getPaymentUI() : this.getNoProcessorUI();
		return ui;
	}

	getNoProcessorUI() {
		var instruction = this.props.paymentConfig.offlineInstr;
		if (instruction === null || instruction.trim().length === 0) {
			instruction = <div className="PaymentInstuctions"><p>Please <Link to="/contact">contact us</Link> to arrange payment.</p></div>;
		}
		return <div className="PaymentProcess">
			<h2>{currentUserInfo.numberAndName()}</h2>
			<div className="PaymentInstructions" dangerouslySetInnerHTML={{ __html: instruction }}/>
		</div>;
	}

	getPaymentUI() {
		var ui = null;
		switch (this.state.paymentState) {
		case PaymentStates.entryForm:
		case PaymentStates.processExternal:
			ui =
					<div className="PaymentProcess">
						<h2>{currentUserInfo.numberAndName()}</h2>
						<h2>Make a Payment</h2>
						<PaymentSummary
							pastDueTotal={this.pastDueInvoiceTotal}
							prepaidAdTotal={this.prepaidAdTotal}
							currentTotal={this.currentInvoiceTotal}
							billedAdTotal={this.billedAdTotal}
						/>
						<hr />
						<PaymentError errorText={this.state.paymentError} />
						<CreditCardEntry
							showCCEntry={!this.props.paymentConfig.entervialink}
							externalProcessData={this.state.externalProcessorData}
							cardHolders={this.cardHolders}
							paymentMethods={this.paymentMethods}
							submitPaymentAction={this.submitPayment}
							defaultPaymentData={this.state.paymentInfo}
							validationMessages={this.state.fieldValidationMessages}
						/>
						<PaymentError errorText={this.state.paymentError} />
					</div>;
			break;
		case PaymentStates.submitting:
			ui =
					<div className="PaymentProcess">
						<h2>Processing Payment Information...</h2>
					</div>;
			break;
		case PaymentStates.showReceipt:
			var ads = this.props.itemsToPay.prepaidAds ? this.props.itemsToPay.prepaidAds.slice() : [];
			if (this.props.itemsToPay.billedAds) {
				ads.push.apply(ads, this.props.itemsToPay.billedAds); //JS's hacky way of combining arrays
			}
			var invoices = this.props.itemsToPay.pastDueInvoices ? this.props.itemsToPay.pastDueInvoices.slice() : [];
			if (this.props.itemsToPay.currentInvoices) {
				invoices.push.apply(invoices, this.props.itemsToPay.currentInvoices);
			}
			ui =
					<div className="PaymentProcess">
						<Receipt
							paymentNumber={this.state.paymentNumber}
							paymentInfo={this.state.paymentInfo}
							adsPaid={ads}
							invoicesPaid={invoices}
							doneAction={this.done}
						/>
					</div>;
			break;
		case PaymentStates.payableChanged:
			ui =
					<div className="PaymentProcess">
						<p>{this.state.paymentError}</p>
						<Button label="Reload" onMouseUp={this.done} raised primary />
						<br />
						<p>Feel free to <Link to="/contact">Contact us</Link> if you would like our assistance.</p>
					</div>;
			break;
		case PaymentStates.fatalError:
			ui =
					<div className="PaymentProcess">
						<p>{this.state.paymentError}</p>
						<p>Please <Link to="/contact">Contact us</Link> for further assistance.</p>
					</div>;
			break;
		default:
			ui = <h1>Programming error: illegal PaymentState = {this.state.paymentState}</h1>;
		}
		return ui;
	}
}

Pay.propTypes = {
	paymentConfig: PropTypes.object,
	itemsToPay:PropTypes.object.isRequired,
	server: PropTypes.func,
	routerHistory: PropTypes.object
};

function PaymentSummary(props) {
	let PastDueInvoiceLine = () => props.pastDueTotal > 0 ?
		<tr>
			<th className="money">Past Due Invoices:</th>
			<td className="money">{props.pastDueTotal.formatMoney()}</td>
		</tr> :
		<tr></tr>;
	let PrepayAdLine = () => props.prepaidAdTotal > 0 ?
		<tr>
			<th className="money">Ads Requiring Prepayment:</th>
			<td className="money">{props.prepaidAdTotal.formatMoney()}</td>
		</tr> :
		<tr></tr>;
	let RecentInvoiceLine = () => props.currentTotal > 0 ?
		<tr>
			<th className="money">Current Invoices:</th>
			<td className="money">{props.currentTotal.formatMoney()}</td>
		</tr> :
		<tr></tr>;
	let BilledAdLine = () => props.billedAdTotal > 0 ?
		<tr>
			<th className="money">Ads Not Yet Invoiced:</th>
			<td className="money">{props.billedAdTotal.formatMoney()}</td>
		</tr> :
		<tr></tr>;

	let totalPayment = props.pastDueTotal + props.prepaidAdTotal + props.currentTotal + props.billedAdTotal;

	let TotalLine = () =>
		<tr>
			<th className="money">Total Payment:</th>
			<th className="money">{totalPayment.formatMoney()}</th>
		</tr>;

	return (
		<div className="CustomerAccountInfo-PayableSummary">
			<h3>Summary of Items to Pay</h3>
			<table>
				<thead>
					<tr>
						<th></th>
						<th className="money">Payment Amount</th>
					</tr>
				</thead>
				<tbody>
					<PastDueInvoiceLine />
					<PrepayAdLine />
					<RecentInvoiceLine />
					<BilledAdLine />
				</tbody>
				<tfoot>
					<TotalLine />
				</tfoot>
			</table>
		</div>
	);
}

PaymentSummary.propTypes = {
	pastDueTotal: PropTypes.number,
	prepaidAdTotal: PropTypes.number,
	currentTotal: PropTypes.number,
	billedAdTotal: PropTypes.number
};

function PaymentError(props) {
	return (
		props.errorText ?
			<div className="PaymentErrorReport">
				<h3>Your payment could not be processed</h3>
				<p>{props.errorText}</p>
			</div> :
			null
	);
}

PaymentError.propTypes = {
	errorText: PropTypes.string
};

class CreditCardEntry extends Component {

	constructor(props) {
		super(props);

		this.submitPayment = this.submitPayment.bind(this);

		this.formFieldDisablers = {
			billFirstName: this.isEntryFieldDisabled,
			billLastName: this.isEntryFieldDisabled,
			billStreet: this.isEntryFieldDisabled,
			billStreet2: this.isEntryFieldDisabled,
			billCity: this.isEntryFieldDisabled,
			billState: this.isEntryFieldDisabled,
			billPostalCode: this.isEntryFieldDisabled,
			billPhone: this.isEntryFieldDisabled
		};

		//Note that this won't work if the the props.cardHolders
		//changes while this is being displayed. I don't anticipate
		//that happening, but if it ever does, this will have to be
		//moved either to `render` or `getDerivedStateFromProps`.
		//Since it won't be a big list, `render` would probably be fine.
		this.cardHolderModel = props.cardHolders ? props.cardHolders.map((cardHolder, idx) => {
			const value = idx;

			const name = delimit(cardHolder.billFirstName, cardHolder.billLastName, " ");
			const streets = delimit(cardHolder.billStreet, cardHolder.billStreet2, ", ");
			const label = delimit(name, streets, ": ");

			return { value: value, label: label };
		}) : [];

		this.cardHolderModel.push({
			value: -1,
			label: "Enter New Address"
		});

		//The value of each item is its index into the `cardHolders` array.
		this.cardHolderTranslator = props.cardHolders ? {
			toDisplayValue: value => {
				const idx = this.props.cardHolders.findIndex(ch => ch.id === value.id);
				return idx;
			},

			toStorageValue: value => {
				let cardHolder = value >= 0 ? this.props.cardHolders[value] : null;
				return cardHolder;
			}
		} : null;
	}

	//Called by ValidatedForm whenever a value is set. This
	//Sets all the address fields to the values from the
	//selected cardholder.
	setAddressFieldValues(fieldName, value, currentFieldValues) {
		var returnVals = null;
		if (fieldName === "cardHolder") {
			const cardHolderVals = value ? value : {
				id: 0,
				billFirstName: "",
				billLastName: ""
			};
			returnVals = Object.assign({}, currentFieldValues, cardHolderVals, { cardHolder: cardHolderVals });
		}
		return returnVals;
	}

	submitPayment(paymentFormData) {
		// console.log("Raw form data passed to submit is ", paymentFormData);
		var paymentData = {
			pmtMethod: paymentFormData.pmtMethod,
			cardNumber: paymentFormData.cardNumber,
			expMonth: paymentFormData.expMonth,
			expYear: paymentFormData.expYear,
			cvCode: paymentFormData.cvCode
		};
		const cardHolderSet = paymentFormData.cardHolder;
		if (cardHolderSet && cardHolderSet.id !== 0) {
			var saveCardHolder = Object.assign({}, cardHolderSet);
			delete saveCardHolder["@javaType"];
			paymentData.cardHolder = saveCardHolder;
		} else {
			paymentData.cardHolder = {
				id: null,
				billFirstName: paymentFormData.billFirstName,
				billLastName: paymentFormData.billLastName,
				billStreet: paymentFormData.billStreet,
				billStreet2: paymentFormData.billStreet2,
				billCity: paymentFormData.billCity,
				billState: paymentFormData.billState,
				billPostalCode: paymentFormData.billPostalCode,
				billPhone: paymentFormData.billPhone
			};
		}
		this.props.submitPaymentAction(paymentData);
	}

	isEntryFieldDisabled(fieldName, fieldValue, formData) {

		if (fieldName.startsWith("bill")) {
			return formData.cardHolder ? formData.cardHolder.id !== 0 : false;
		}
		return false;
	}

	render () {
		// const minExpYear = new Date().getYear();
		//ValidatedForm doesn't handle sub-fields yet, so pull out the address fields
		//from the default card holder.
		const defaultPayment = this.props.defaultPaymentData ? this.props.defaultPaymentData : null;
		var cardHolder = defaultPayment ? defaultPayment.cardHolder : {};
		cardHolder = cardHolder ? cardHolder : {};
		const formPaymentData = Object.assign({}, this.props.defaultPaymentData, cardHolder);
		var ccForm = null;
		var extForm = null;
		var heading = null;
		var submitBtn = null;
		if (this.props.showCCEntry) {
			heading = <h3>Enter Your Credit Card Information</h3>;
			submitBtn = "Submit Payment";
			ccForm =
				<div className="PaymentForm_CreditCardInfo">
					<p className="PaymentFormSectionLabel">Credit Card Information</p>
					<DropdownAdapter
						fieldName="pmtMethod"
						componentProps={{
							label: "Credit Card Type",
							source: this.props.paymentMethods,
							required: true
						}}
					/>
					<InputAdapter
						fieldName="cardNumber"
						componentProps={{
							label: "Card Number",
							type: "text",
							required: true
						}}
					/>
					<InputAdapter
						fieldName="expMonth"
						componentProps={{
							label: "Expiration Month (1-12)",
							type: "number",
							step: "1",
							min: "1",
							max: "12",
							required: true
						}}
					/>
					<InputAdapter
						fieldName="expYear"
						componentProps={{
							label: "Expiration Year (yyyy)",
							type: "number",
							step: "1",
							min: "0",
							max: "",
							required: true
						}}
					/>
					<InputAdapter
						fieldName="cvCode"
						componentProps={{
							label: "Security Code",
							type: "text",
							required: false
						}}
					/>
				</div>;
		} else {
			heading = <h3>Enter Your Billing Information</h3>;
			submitBtn = "Enter Payment";
		}
		if (this.props.externalProcessData !== null) {
			extForm = <ExternalProcessor processorData={this.props.externalProcessData}/>;
		}
		return (
			<div className="PaymentForm">
				{heading}
				<ValidatedForm
					onSubmit={this.submitPayment}
					initialValues={formPaymentData}
					formFieldDisablers={this.formFieldDisablers}
					fieldValueCalculator={this.setAddressFieldValues}
					// dataValidationMessage={errMsg}
					validationMessages={this.props.validationMessages}
					submitButtonLabel={submitBtn}
				>
					<div className="PaymentForm_CardHolderInfo" id="paymentForm_CH">
						<p className="PaymentFormSectionLabel">Cardholder Information</p>
						<DropdownAdapter
							fieldName="cardHolder"
							translator={this.cardHolderTranslator}
							componentProps={{
								label: "Card Holder Name & Billing Address",
								source: this.cardHolderModel,
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billFirstName"
							componentProps={{
								label: "Card Holder First Name",
								type: "text",
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billLastName"
							componentProps={{
								label: "Card Holder Last Name",
								type: "text",
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billStreet"
							componentProps={{
								label: "Credit Card Billing Street Address",
								type: "text",
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billCity"
							componentProps={{
								label: "Credit Card Billing City",
								type: "text",
								required: true,
								id: "billCity_Fld"
							}}
						/>
						<InputAdapter
							fieldName="billState"
							componentProps={{
								label: "Credit Card Billing State",
								type: "text",
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billPostalCode"
							componentProps={{
								label: "Credit Card Billing Zip Code",
								type: "text",
								required: true
							}}
						/>
						<InputAdapter
							fieldName="billPhone"
							componentProps={{
								label: "Credit Card Billing Phone Number",
								type: "text",
								required: true
							}}
						/>
					</div>
					{ccForm}
				</ValidatedForm>
				{extForm}
			</div>
		);
	}
}

CreditCardEntry.propTypes = {
	showCCEntry: PropTypes.bool,
	cardHolders: PropTypes.array,
	paymentMethods: PropTypes.array,
	submitPaymentAction: PropTypes.func,
	defaultPaymentData: PropTypes.object,
	validationMessages: PropTypes.object,
	externalProcessData: PropTypes.object
};

class ExternalProcessor extends Component {

	closePopup() {
		AuthorizeNetPopup.closePopup();
	}

	render() {
		let postParams = Object.entries(this.props.processorData.postParams);
		let iframeClass = "PaymentIframeTheme";
		if (this.props.processorData.postParams.hasOwnProperty("SECURETOKENID")) {
			iframeClass="PayFlowIframeTheme";
		}
		return (
		<div className="ExternalProcessor">
			<div id="divPaymentPopupScreen"></div>
			<form name="ShowProcessorForm" action={this.props.processorData.postURL} method="post" target="iframePayment">
				{postParams.map(pp => {
					if (pp[0] !== "@javaType") {
						return (
							<input type="hidden" name={pp[0]} value={pp[1]} readOnly />
						);
					}
				})}
			</form>
			<div id="divPaymentPopup" className="PaymentPopupGrayFrameTheme">
				<div className="PaymentPopupOuter">
					<div className="PaymentPopupTop">
						<div className="PaymentPopupClose">
							<a href="javascript:;" onClick={this.closePopup} title="Close">X</a>
						</div>
					</div>
					<div className="PaymentPopupInner">
						<iframe name="iframePayment" id="iframePayment" src="extpmt.html"
						frameborder="0" scrolling="auto" className={iframeClass}></iframe>
					</div>
				</div>
			</div>;
		</div>);
	}

	componentDidMount() {
		document.ShowProcessorForm.submit();
	}
}

ExternalProcessor.propTypes = {
	processorData: PropTypes.object
};


function Receipt(props) {
	let dateOpts = { month: "long", day: "numeric", year: "numeric" };
	let todayStr = new Date().toLocaleDateString("en-US", dateOpts);
	let cityState = delimit(currentUserInfo.customerCity, currentUserInfo.customerState, ", ");
	let cityStateZip = delimit(cityState, currentUserInfo.customerZip, " ");
	let address = (
		<div className="PaymentReceipt_NameAddress">
			{currentUserInfo.numberAndName()}<br />
			Paid By: {currentUserInfo.userFullName}<br />
			{currentUserInfo.customerStreet}<br />
			{delimit(currentUserInfo.customerSuite, "", <br />)}
			{cityStateZip}<br />
		</div>
	);
	let slicePos = props.paymentInfo.cardNumber != null && props.paymentInfo.cardNumber.length >= 4 ?
		props.paymentInfo.cardNumber.length - 4 : -1;
	let cardEnding = slicePos >= 0 ? props.paymentInfo.cardNumber.slice(slicePos) : "n/a";
	let paymentInfo = (
		<div className="PaymentReceipt_PaymentInfo">
			Payment Method: {props.paymentInfo.pmtMethod}<br/>
			Card Ending In: {cardEnding}<br/>
			Card Holder: {delimit(props.paymentInfo.cardHolder.billFirstName, props.paymentInfo.cardHolder.billLastName, " ")}
		</div>
	);
	return (
		<div className="PaymentReceipt">
			<h2>Payment Receipt</h2>
			<p><b>Payment Number:</b> {props.paymentNumber}</p>
			<p><b>Payment Date:</b> {todayStr}</p>
			<br/>
			{address}
			<PaidItems ads={props.adsPaid} invoices={props.invoicesPaid} />
			<br/>
			{paymentInfo}
			<div className="ButtonBar">
				<Button label="Done" onMouseUp={props.doneAction} id="DoneReceiptButton" raised primary/>
				<Button label="Print Receipt" onMouseUp={printReceipt} id="PrintReceiptButton" raised primary />
			</div>
		</div>
	);
}

Receipt.propTypes = {
	paymentNumber: PropTypes.number,
	paymentInfo: PropTypes.object,
	adsPaid: PropTypes.array,
	invoicesPaid: PropTypes.array,
	doneAction: PropTypes.func
};

function PaidItems(props) {

	var totalPaid = props.ads ? props.ads.reduce((total, ad) => {
		return total + ad.totalUnpaid;
	}, 0) : 0;
	totalPaid = props.invoices ? props.invoices.reduce((total, invoice) => {
		return total + invoice.receivable;
	}, totalPaid) : 0;

	return (
		<div className="CustomerAccountInfo-ReceiptItemSummary">
			<h3>Items Paid</h3>
			<table>
				<thead>
					<tr>
						<th>Item</th>
						<th>Date</th>
						<th>Description</th>
						<th className="money">Payment Amount</th>
					</tr>
				</thead>
				<tbody>
					{props.invoices.map(invoice => <PaidInvoice invoice={invoice} key={invoice.id}/>)}
					{props.ads.map(ad => <PaidAd ad={ad} key={ad.id} />)}
				</tbody>
				<tfoot>
					<tr>
						<th colSpan="3" className="money">Total Paid</th>
						<th className="money">{totalPaid.formatMoney()}</th>
					</tr>
				</tfoot>
			</table>
		</div>
	);

}

PaidItems.propTypes = {
	ads: PropTypes.array,
	invoices: PropTypes.array
};

function PaidAd(props) {
	let ad = props.ad;
	let adId = ad.id;
	let runDate = ad.firstDate.toLocaleDateString();
	let description = ad.copyRef;
	let amtPaid = (ad.storedCost - ad.amtPrepaid).formatMoney();
	return (
		<tr>
			<td>{"Ad "+adId}</td>
			<td>{runDate}</td>
			<td>{description}</td>
			<td className="money">{amtPaid}</td>
		</tr>
	);
}

PaidAd.propTypes = {
	ad: PropTypes.object
};

function PaidInvoice(props) {
	let invoiceID = props.invoice.id;
	let transDate = props.invoice.transDate.toLocaleDateString();
	let adDesc = props.invoice.adId && props.invoice.adId !== 0 ? "ad "+props.invoice.adId : null;
	var description = delimit(adDesc, props.invoice.description, ": ");
	let amtPaid = props.invoice.receivable.formatMoney();
	return (
		<tr>
			<td>{"Invoice " + invoiceID}</td>
			<td>{transDate}</td>
			<td>{description}</td>
			<td className="money">{amtPaid}</td>
		</tr>
	);
}

PaidInvoice.propTypes = {
	invoice: PropTypes.object
};

function printReceipt() {
	window.print();
}


// WEBPACK FOOTER //
// ./src/components/Pay.js